import React, { useState } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { PlanesAPI } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PlanesForm } from "../PlanesForm"; // Ajusta la ruta a tu componente de formulario
import "./PlanesItem.scss";

const planesController = new PlanesAPI();

export function PlanesItem(props) {
  const { plan, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const { accessToken, user } = useAuth();

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const openUpdatePlan = () => {
    setTitleModal(`Editar plan: ${plan.title}`);
    onOpenCloseModal();
  };

  const onDelete = async () => {
    try {
      // Aquí necesitamos el idPermission (ID de un usuario admin).
      // Ajusta según tu lógica (ej. lo podrías tener en Redux, en el user logueado, etc.).
      const idPermission = user.user._id;
      await planesController.deletePlan(accessToken, idPermission, plan._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error("Error eliminando el plan:", error);
    }
  };

  return (
    <>
      <div className="plan-item">
        <div className="plan-item__info">
          {/* Miniatura: si no hay, usa "/images/no-image.png" */}
          <Image src={plan.miniature || "/images/no-image.png"} />

          <div>
            {/* Título (String) */}
            {plan.title && (
              <h2 style={{ fontWeight: "bold", fontSize: "2rem" }}>
                {plan.title}
              </h2>
            )}

            {/* Descripción (String) */}
            {plan.description && (
              <div>
                {plan.description
                  .match(/.{1,100}/g) // Dividir en grupos de 100 caracteres
                  .map((fragment, index) => (
                    <p key={index}>{fragment}</p>
                  ))}
              </div>
            )}
            {plan.account && (
              <p>
                <strong>Plan Contratado:</strong> {plan.account}
              </p>
            )}
            {/* Número de visores VR (Number): mostramos si es 0 o mayor */}
            {plan.vrHeadsetNumber !== undefined && (
              <p>
                <strong>Nº de Visores VR:</strong> {plan.vrHeadsetNumber}
              </p>
            )}

            {/* Modelo de visor VR (String) */}
            {plan.vrHeadsetModel && (
              <p>
                <strong>Modelo de Visor VR:</strong> {plan.vrHeadsetModel}
              </p>
            )}

            {/* Modelo de maleta (String) */}
            {plan.bagModel && (
              <p>
                <strong>Modelo de maleta:</strong> {plan.bagModel}
              </p>
            )}

            {/* Implantation Configurations (Boolean) */}
            {typeof plan.implantationConfigurations === "boolean" && (
              <p>
                <strong>Implantación:</strong>{" "}
                {plan.implantationConfigurations ? "Sí" : "No"}
              </p>
            )}

            {/* Meses de licencia (Number) */}
            {plan.accessTime !== undefined && (
              <p>
                <strong>Meses de licencia:</strong> {plan.accessTime}
              </p>
            )}

            {/* Publicidad (Boolean) */}
            {typeof plan.publicity === "boolean" && (
              <p>
                <strong>Publicidad:</strong> {plan.publicity ? "Sí" : "No"}
              </p>
            )}

            {/* Número de Profesores (Number) */}
            {plan.teacherNumber !== undefined && (
              <p>
                <strong>Nº de Profesores:</strong> {plan.teacherNumber}
              </p>
            )}

            {/* Número de Estudiantes (Number) */}
            {plan.studentsNumber !== undefined && (
              <p>
                <strong>Nº de Estudiantes:</strong> {plan.studentsNumber}
              </p>
            )}

            {/* Formación de cursos (Boolean) */}
            {typeof plan.curseBasic === "boolean" && (
              <p>
                <strong>Formación iniciación:</strong>{" "}
                {plan.curseBasic ? "Sí" : "No"}
              </p>
            )}
            {/* Formación de cursos (Boolean) */}
            {typeof plan.curseCertification === "boolean" && (
              <p>
                <strong>Formación certificación:</strong>{" "}
                {plan.curseCertification ? "Sí" : "No"}
              </p>
            )}
            {/* Soporte (Boolean) */}
            {typeof plan.support === "boolean" && (
              <p>
                <strong>Soporte:</strong> {plan.support ? "Sí" : "No"}
              </p>
            )}

            {/* Educamaker (Boolean) */}
            {typeof plan.educamaker === "boolean" && (
              <p>
                <strong>Educamaker:</strong> {plan.educamaker ? "Sí" : "No"}
              </p>
            )}

            {/* Precio (Number) */}
            {plan.price !== undefined && (
              <p>
                <strong style={{ color: "red" }}>Precio:</strong> {plan.price}{" "}
                EUR
              </p>
            )}
          </div>
        </div>

        <div className="plan-item__actions">
          {/* Si no hay un "url" que visitar, podrías quitar este botón */}
          {/* <Button icon as="a" href={plan.someUrl} target="_blank">
            <Icon name="eye" />
          </Button> */}
          <Button icon primary onClick={openUpdatePlan}>
            <Icon name="pencil" />
          </Button>
          <Button icon color="red" onClick={onOpenCloseConfirm}>
            <Icon name="trash" />
          </Button>
        </div>
      </div>

      {/* Modal para Editar */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={titleModal}
        size="large"
      >
        <PlanesForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          plan={plan}
          idPermission={user._id}
        />
      </BasicModal>

      {/* Confirm para Eliminar */}
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`¿Estás seguro de eliminar el plan "${plan.title}"?`}
        size="mini"
      />
    </>
  );
}
